import {HttpTransportType, HubConnectionBuilder} from '@aspnet/signalr';

export const CARD_READ = 'CardRead';
export const CARD_REMOVED = 'CardRemoved';
export const CARD_INSERTED = 'CardInserted';
export const CARD_ERROR_READ = 'CardErrorRead';
export const CONNECTED_READER = 'ConnectedReader';
export const DISCONNECTED_READER = 'DisconnectedReader';
export const PRINT_RECEIPT = 'PrintReceipt';

export default async function() {
  try {
    const builder = new HubConnectionBuilder();
    const options = process.env.NODE_ENV === 'development' ? {
      skipNegotiation: true,
      transport: HttpTransportType.WebSockets
    } : {};
    const signalR = builder.withUrl('http://localhost:5000/reader/hub', options).build();
    await signalR.start();
    return signalR;
  } catch (e) {
    console.log(e);
  }
};

